module.exports = __webpack_public_path__ + "static/abby-3883676c0b0f2dd5e27b81d837a5d544.jpg";